export default "__VITE_ASSET__BdVvVFQ2__"